<template>
  <section class="section row about"><!-- v-bind:style="{ backgroundImage: 'url(https://media.sfdermato.org/reco/template/chronoreco.svg)' }"-->
    <div class="row col-lg-12">
    	<div class="col-lg-8">
      		<introduction/>
    	</div>
    	<div class="col-lg-4">
    		<img src="//media.sfdermato.org/chronoreco/template/chronoreco_halfphone.svg" alt="Votre reco dermato en une minute chrono !">
    	</div>
    </div>
    <aside class="row">
      <!-- <card-about/> -->
      <a href="/info/centre-de-preuves-en-dermatologie" title="Consulter le site">Application alimentée par les recommandations du <b>Centre de Preuves en Dermatologie de la SFD</b></a>
    </aside>
  </section>
</template>

<script>
//import CardAbout from "../Card/Models/Card-about";
  import Introduction from "./Introduction";


  export default {
    name: "About",
    components: {
      Introduction,
      //CardAbout
    },
  }
</script>

<style lang="scss">
  section.about {
    padding-bottom:0!important;
    overflow:hidden;

    .row > .col-lg-4 {

    	display:flex;
    	align-items:flex-end;

    	img {width:100%;max-width:100%}
    }

    aside {
      width:auto;
      background:color(more);
      color:white;
      height:3em;

      transform:skew(-1deg) rotate(-1deg);
      margin:0 0 -.5em auto;

      a{
      	display:block;
      	width:100%;
      	padding:.8em 1em .5em 1em;
      	text-align:center;
      	color:inherit;
      	font-family:'Montserrat';
  	    transform:skew(1deg) rotate(1deg);
      }
    }

    @include mq($until: MD) {
      padding-bottom: 0!important;
      background-size: auto;
      background-position: top;

      aside {height:auto;padding:.33em 2rem .66em;width:100%;margin-top:-1em; b {display:block}}

      .row > .col-lg-4 {

      	justify-content:right;

      	img {max-width:48%;min-width:400px;margin-right:2%;margin-bottom:-100px}

      }

    }

  }
</style>
